import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook.tsx';
import { queryKeys } from '@queries/keys.ts';
import { useQuery } from '@tanstack/react-query';
import { PhysicalIntegrationSelectDto, PhysicalIntegrationsSelectDto } from '../types/api.types';

export const useGetPhysicalIntegrations = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<PhysicalIntegrationSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<PhysicalIntegrationsSelectDto>({
        path: '/v1/data/physical-integrations',
      });
      return result.physicalIntegrations;
    },
    queryKey: enabled ? queryKeys.physicalIntegration.getPhysicalIntegrations : queryKeys.placeholders.default,
  });
};
